module.exports = __webpack_public_path__ + "img/anna-pro.34758178.jpg";